import { useQuery } from "@tanstack/react-query";
import { chatApi } from "../../api/chat";

/**
 * Hook to get list of pinned message IDs in a room
 * @param roomId - Chat room ID
 * @returns Query object with pinned message IDs
 */
export const useGetPinnedMessageIds = (roomId: string) => {
  return useQuery({
    queryKey: ["pinned-message-ids", roomId],
    queryFn: () => chatApi.getPinnedMessageIds(roomId),
    enabled: !!roomId,
    staleTime: 30000, // Cache for 30 seconds
  });
};
